import React from "react";

export default function Table({ list, total, deposit }) {
  return (
    <>
      <table width="100%" className="mb-10">
        <thead>
          <tr className="bg-gray-100 p-1">
            <td className="font-bold">Description</td>
            <td className="font-bold">Qty</td>
            <td className="font-bold text-right">Unit Price</td>
            <td className="font-bold text-right">Total</td>
          </tr>
        </thead>
        {list.map(({ id, description, quantity, price, amount }) => (
          <React.Fragment key={id}>
            <tbody>
              <tr className="text-sm h-10">
                <td>{description}</td>
                <td>{quantity}</td>
                <td className="text-right">{Number(price).toLocaleString()}</td>
                <td className="text-right">{amount.toLocaleString()}</td>
              </tr>
            </tbody>
          </React.Fragment>
        ))}
      </table>

      <div>
        <h2 className="flex items-end justify-end text-gray-800">
          Total: {total.toLocaleString()} rp
        </h2>
        {deposit > 0 && (
          <h3 className="flex items-end justify-end">
            Deposit (by transfer): (-{Number(deposit).toLocaleString()}) rp
          </h3>
        )}
        <h3 className="flex items-end justify-end  text-xl font-bold">Rest to Pay: {(total-deposit).toLocaleString()} rp</h3>
      </div>
    </>
  );
}
